<ng-container *ngIf="antwoordResultaat && antwoordResultaat.antwoorden && antwoordResultaat.antwoorden.length === 1">
  <div data-hj-suppress class="ols-summary-answer" [innerHTML]="geefAntwoord()"></div>
</ng-container>

<ng-container *ngIf="antwoordResultaat && antwoordResultaat.antwoorden && antwoordResultaat.antwoorden.length > 1">
  <div class="ols-table">
    <div *ngFor="let antw of antwoordResultaat.antwoorden" class="ols-table-row">
      <div class="ols-table-cell ols-table-cell-cg">{{antw.titel}}</div>
      <div data-hj-suppress class="ols-table-cell">{{antw.waarde}}</div>
    </div>
  </div>
</ng-container>